export const personalInfo = {
  name: "Warre Van Tittelboom",
  title: "Gameplay Programmer / Aspiring Game Designer",
  email: "warrevantittelboom@gmail.com",
  profileImage: "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/85f6ddd7-10c7-45ae-9060-e3149269dbce/gb_andrew-modified.png",
  aboutImage: "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/9aba4c27-3dfe-4ddb-b3c2-b86ffec6d2bb/Knipsel-modified.png",
  bio: "I'm Warre, a game development graduate with a passion for programming and a keen interest in game design. Since I first started playing games as a toddler not a single day has passed where [...]",
  socialLinks: {
    github: "https://github.com/WarreVannTittelboom",
    linkedin: "https://www.linkedin.com/in/warrevantittelboom/",
    itch: "https://warrevt.itch.io/"
  },
  resumeUrl: "/_resume.pdf"
};

export const projects = [
  {
    id: "split-my-ride",
    title: "Split My Ride",
    thumbnail: "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/1697046858405-IPZO4QIQ5MG1XLYC334I/splitmyride.png",
    images: [
      "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/220d3f57-82a8-40b4-bab8-da8712b4028a/hF2yGC.png"
    ],
    shortDescription: "Endless runner couch coop game with a unique twist",
    description: "Split My Ride is the result of an assignment where we were tasked with developing a complete vertical slice of a game concept. Our only constraints were that it had to offer eith[...]",
    language: "Unity",
    type: "Group Project",
    technologies: ["Unity", "C#", "Couch Co-op"],
    links: {
      itch: "https://warrevt.itch.io/split-my-ride",
      youtube: "https://www.youtube.com/watch?v=cAMj260NAM4"
    },
    team: [
      { name: "Maxim Deduytsche", role: "Artist" },
      { name: "Josim Coussens", role: "Artist" },
      { name: "Kevin Shawn Perlado Calacapa", role: "Artist" },
      { name: "Victor Verlaenen", role: "Programmer" },
      { name: "Warre Van Tittelboom", role: "Programmer" }
    ],
    featured: true
  },
  {
    id: "text-n-drive",
    title: "Text 'N Drive",
    thumbnail: "/text-n-drive.png",
    images: [
      "/text-n-drive.png"
    ],
    shortDescription: "Driving simulator showcasing texting and driving dangers",
    description: "Text 'N Drive is a project I worked on during my internship focused on raising awareness about the dangers of texting while driving. The core concept was to create an immersive s[...]",
    language: "Unity",
    type: "Internship Project",
    technologies: ["Unity", "C#", "Firebase", "Mobile Integration"],
    links: {
      youtube: "https://youtu.be/yu-V5oMqMUg"
    },
    team: [
      { name: "Warre Van Tittelboom", role: "Programmer" },
      { name: "Floris Leirs", role: "Programmer" }
    ],
    featured: true
  },
  {
    id: "tron-remake",
    title: "Tron Remake",
    subtitle: "Tron Tanks Remake",
    thumbnail: "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/1697047143728-GBICUQXK7KFP57Y8DBF1/tron.PNG",
    images: [
      "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/62b26375-48b5-4a1c-9f1f-3a498a284e6f/tron.PNG",
      "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/b67f8e30-a4a5-4dde-9e71-fea145b4a537/Animatie.gif"
    ],
    shortDescription: "Remake of the Tron arcade game in my own 2D game engine",
    description: "This project is the culmination of an exam assignment where the goal was to create a 2D C++ game engine essentially from the ground up and recreate a classic arcade game in it. I[...]",
    language: "C++",
    type: "Solo Project",
    technologies: ["C++", "Custom Game Engine", "SDL"],
    links: {
      repo: "https://github.com/WarreVannTittelboom/2DAE14_Programming4_VanTittelboom_Warre"
    },
    featured: false
  },
  {
    id: "classified-vr",
    title: "Classified VR Project",
    thumbnail: "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/1697048001014-5NKXKUGHNUTQ1KQJ7000/Knipsel.PNG",
    images: [
      "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/8d268854-55bb-4a86-8ff9-a6d673f4dbaf/vr-headset-2048px-9008.jpg"
    ],
    shortDescription: "Immersive VR simulation game with custom controller",
    description: "The goal of this project was to develop an immersive VR simulation game, featuring a custom controller. Unfortunately, due to the confidential nature of the project, I cannot dis[...]",
    language: "VR Development",
    type: "Group Project",
    technologies: ["VR", "Unity", "C#"],
    links: {},
    team: [
      { name: "Hannes De Wispelaere", role: "Producer" },
      { name: "Leon Heytens", role: "Artist" },
      { name: "Seppe Willems", role: "Artist" },
      { name: "Connor De Meyer", role: "Programmer" },
      { name: "Sam Vanden Bosch", role: "Programmer" },
      { name: "Warre Van Tittelboom", role: "Programmer" }
    ],
    featured: false
  },
  {
    id: "ratchet-clank",
    title: "Ratchet & Clank",
    thumbnail: "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/1697047920020-QJMEEIWVOL1O6M1PMM72/004-wallpaper-3824-1280x1024-2033.jpg",
    images: [
      "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/1697047920020-QJMEEIWVOL1O6M1PMM72/004-wallpaper-3824-1280x1024-2033.jpg"
    ],
    shortDescription: "Graphics programming showcase with animations and particles",
    description: "In the Graphics Programming 2 course, our task was to design a small game segment, demonstrating the features we had implemented into our the overlord engine, such as animations[...]",
    language: "C++",
    type: "Solo Project",
    technologies: ["C++", "DirectX", "Overlord Engine"],
    links: {
      repo: "https://github.com/WarreVannTittelboom/RatchetClank",
      youtube: "https://youtu.be/HxPMnHffVzY"
    },
    featured: false
  },
  {
    id: "graphics-programming",
    title: "Graphics Programming",
    thumbnail: "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/1697047551375-W9LW24U4ATTXTTH127F3/Raytracer.gif",
    images: [
      "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/1697047551375-W9LW24U4ATTXTTH127F3/Raytracer.gif",
      "https://images.squarespace-cdn.com/content/v1/63d52b0d8347da088ca05398/80cf950b-2276-4076-868f-90bcf4fb4ec0/HardwareRasterizer.gif"
    ],
    shortDescription: "Raytracer and rasterizer implementation",
    description: "In the course Graphics Programming 1 we learned how to render meshes to the viewport using both the raytracer and a rasterizer technique. We even implemented rasterization both [...]",
    language: "C++",
    type: "Solo Project",
    technologies: ["C++", "Raytracing", "Rasterization", "DirectX"],
    links: {
      repo: "https://github.com/WarreVannTittelboom/gp1"
    },
    featured: false
  }
];

export const skills = {
  programmingLanguages: [
    { name: "C++", level: "Advanced" },
    { name: "C#", level: "Advanced" },
    { name: "HLSL", level: "Intermediate" },
    { name: "Python", level: "Intermediate" },
    { name: "JavaScript", level: "Basic" }
  ],
  softwareTools: [
    { name: "Visual Studio", level: "Advanced" },
    { name: "Unity", level: "Advanced" },
    { name: "Unreal Engine", level: "Intermediate" },
    { name: "Perforce", level: "Intermediate" },
    { name: "Github", level: "Intermediate" },
    { name: "PhotoShop", level: "Intermediate" },
    { name: "Maya", level: "Basic" },
    { name: "Blender", level: "Basic" },
    { name: "Houdini", level: "Basic" }
  ],
  softSkills: [
    "Clear Communication",
    "Patient",
    "Supportive",
    "Responsible",
    "Driven",
    "Curious",
    "Brainstorming"
  ],
  languages: [
    { name: "Dutch", level: "Native" },
    { name: "English", level: "Fluent" },
    { name: "French", level: "Basic" }
  ]
};
